module.exports = __webpack_public_path__ + "img/books-grey.91336387.svg";